import { Injectable } from '@angular/core';
import DriverRequest from '../interfaces/driverRequest';
import DriverLicense from '../interfaces/driverLicense';
import { environment } from '../../environments/environment'
import axios from 'axios';
import QuestionSet from '../interfaces/IDQuiz/LexisNexisWebApi/GetQuizResponse/questionSet';
import UserIdentityRequest from '../interfaces/IDQuiz/LexisNexisWebApi/GetQuizRequest/userIdentityRequest';
import VerifyQuizRequest from '../interfaces/IDQuiz/LexisNexisWebApi/VerifyQuizRequest/verifyQuizRequest';
import Question from '../interfaces/IDQuiz/LexisNexisWebApi/GetQuizResponse/question';
import AnsweredQuestion from '../interfaces/IDQuiz/LexisNexisWebApi/VerifyQuizRequest/questionAnswer';
import RenderDriverReportRequest from '../interfaces/renderReportRequest';
import { DriverReportView } from '../interfaces/driverReportView';
import { RecordsService } from './records.service';
import authHeader from '../helpers/auth-header';
import DriverDTO from '../interfaces/driverDTO';
import { DateTime } from 'luxon';
import License from '../interfaces/IDQuiz/LexisNexisWebApi/GetQuizRequest/license';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { IWizard } from '../interfaces/iwizard';
import { WizardSteps } from '../interfaces/wizard-steps';
import { UserProfile } from '../interfaces/UserProfile';


@Injectable({
     providedIn: 'root'
})
export class DriverRecordRequestService {

     public justSubscribe: boolean = false;
     userProfile?: UserProfile;
     isLexisNexisOn: boolean = true;
     
     ccpTokenHistory: string[] = [];
     isDriverRequestInitialized = false;
     conversationId: string = '';
     smsVerifyTryCount: number = 0;

     driverRequest: DriverRequest = {
          driversLicenses: [],
          billingAddressSame: false,
          driverHasConsented: false,
          id: '',
          address: {
               addressLine1: '', addressLine2: '', city: '', country: 'USA', phoneNumber: '', state: '', zip: '', faxNumber: '', altPhoneNumber: '', countryId: 0
          },
          sendSmsMonitoringUpdates: false,
          isEnrolledInRecordChangeNotifications: false
     };

     orderWizard: IWizard = {
          steps: [
               { step: 1, text: 'Get Started' } as WizardSteps,
               { step: 2, text: 'Your Information' } as WizardSteps,
               { step: 3, text: 'Review' } as WizardSteps,
               { step: 4, text: 'Payment' } as WizardSteps,
               { step: 5, text: 'Done' } as WizardSteps
          ],
          totalSteps: 10,
          type: 'order',
          _cancelLinkRoute: '/',
          visualProgressStep(currentPane: number): number {
               if (currentPane <= 3) {
                    return 1;
               } else if (currentPane > 3 && currentPane <= 6) {
                    return 2;
               } else if (currentPane === 7) {
                    return 3;
               } else if (currentPane === 8 || currentPane === 9) {
                    return 4;
               } else {
                    return 6;
               }
          },
          backLinkRoute(currentPane: number): string {
               if (currentPane > 1 && currentPane <= 9) {
                    return  `/driver/${currentPane - 1}`;
               } 
               return '/driver/11';
          },
          continueLinkRoute(currentPane: number): string {
               if (currentPane > 0 && currentPane < 9) {
                    return `/driver/${currentPane + 1}`;
               } 
               return '/driver/11';
          }
     }

     monitoringWizard: IWizard = {
          steps: [
               { step: 1, text: 'Get Started' } as WizardSteps,
               { step: 2, text: 'Your Information' } as WizardSteps,
               { step: 3, text: 'Review' } as WizardSteps,
               { step: 4, text: 'Done' } as WizardSteps
          ],
          totalSteps: 9,
          type: 'monitor',
          _cancelLinkRoute: '/',
          visualProgressStep(currentPane: number): number {
               if (currentPane <= 3) {
                    return 1;
               } else if (currentPane > 3 && currentPane <= 6) {
                    return 2;
               } else if (currentPane === 6 || currentPane === 7) {
                    return 3;
               } else {
                    return 4;
               }
          },
          backLinkRoute(currentPane: number): string {
               if (currentPane > 1 && currentPane <= 8) {
                    return  `/driver/${currentPane - 1}/subscribe`;
               } 
               return '/driver/11';
          },
          continueLinkRoute(currentPane: number): string {
               if (currentPane > 0 && currentPane < 8) {
                    return `/driver/${currentPane + 1}/subscribe`;
               } 
               return '/driver/11';
          }
     }

     reorderWizard: IWizard = {
          steps: [
               { step: 1, text: 'Get Started' } as WizardSteps,
               { step: 2, text: 'Your Information' } as WizardSteps,
               { step: 3, text: 'Review' } as WizardSteps,
               { step: 4, text: 'Payment' } as WizardSteps,
               { step: 5, text: 'Done' } as WizardSteps
          ],
          totalSteps: 4,
          type: 'reorder',
          _cancelLinkRoute: '/driverDashboard',
          visualProgressStep(currentPane: number): number {
               if (currentPane === 1) {
                    return 1;
               } else if (currentPane === 2) {
                    return 3;
               } else if (currentPane === 7) {
                    return 5;
               } else if (currentPane === 3) {
                    return 4;
               } else {
                    return 2;
               }
          },
          backLinkRoute(currentPane: number): string {
               if (currentPane === 2) {
                    // From Review, back is actually Edit, which goes to Contact Info
                    return '/driver/4/reorder'
               } else if (currentPane === 3) {
                    // From Billing Address, back is Review
                    return  `/driver/2/reorder`;
               } else if (currentPane === 4){
                    // From Contact Info, back is Disclaimers
                    return  `/driver/1/reorder`;
               } else if (currentPane === 5 || currentPane === 6){
                    // From Contact Info, back is Disclaimers
                    return  `/driver/${currentPane - 1}/reorder`;
               }
               return '/driver/11';
          },
          continueLinkRoute(currentPane: number): string {
                if (currentPane >= 1 && currentPane < 6) {
                    // Disclaimers next is Review 
                    // Review next is Billing Address
                    // Contact Info next is Address
                    // Address next is Licenses
                    return  `/driver/${currentPane + 1}/reorder`;
               } else if (currentPane === 6) {
                    // License next is Review
                    return  `/driver/2/reorder`;
               } 
               return '/driver/11';
          }
     }

     constructor (private recordsService: RecordsService,
          private http: HttpClient,
          private authService: AuthenticationService) {
          if (this.loadFromLocal() === false) {
               this.new();
          }
          this.justSubscribe = false;
          this.userProfile = this.authService.getUserProfile();
          this.populateIsLexisNexisOn();
     }

     isReorder():boolean {
          return this.userProfile?.userData?.roles.includes('driver') ?? false;
     }

     new() {
          
          this.driverRequest = {
               driversLicenses: [],
               billingAddressSame: false,
               driverHasConsented: false,
               id: '',
               address: {
                    addressLine1: '', addressLine2: '', city: '', country: 'USA', phoneNumber: '', state: '', zip: '', faxNumber: '', altPhoneNumber: '', countryId: 0
               },
               sendSmsMonitoringUpdates: false,
               isEnrolledInRecordChangeNotifications: false
          }

          this.justSubscribe = false;
          this.isDriverRequestInitialized = true;
     }

     getWizard() {
          if (this.justSubscribe) {
               return this.monitoringWizard;
          } else if (this.isReorder()){
               return this.reorderWizard;
          } else {
               return this.orderWizard;
          }
     }

     getEmailForLicense(driverLicense: DriverLicense): any {
          const url: string = `${environment.APP_API_URL}/api/v1/applicant/getEmailForLicense`;
          return axios.post(url, driverLicense, {
               headers: {
                    'Content-Type': 'application/json'
               }
          })
               .then((response) => (response.data as string))
               .catch((error) => {
                    console.error(error);
                    return '';
               });
     }

     getEmailForLicenseId(driverLicenseId: string): any {
          const url: string = `${environment.APP_API_URL}/api/v1/Applicant/getEmailForLicenseId`;
          return axios.post(url, driverLicenseId, {
               headers: {
                    'Content-Type': 'application/json'
               }
          })
               .then((response) => (response.data as string))
               .catch((error) => {
                    console.error(error);
                    return '';
               });
     }

     doesLicenseExist(driverLicense: DriverLicense): any {
          const url: string = `${environment.APP_API_URL}/api/v1/applicant/doesLicenseExist`;
          return axios.post(url, driverLicense, {
               headers: {
                    'Content-Type': 'application/json'
               }
          })
               .then((response) => (response.data as boolean))
               .catch((error) => {
                    console.error(error);
                    return false;
               });
     }

     doesEmailExist(email: string): any {
          if (email) {
               const url: string = `${environment.APP_API_URL}/api/v1/applicant/doesEmailExist/${email}`;
               return axios.get(url)
                    .then((response) => (response.data as any))
                    .catch((error) => {
                         console.error(error);
                         return [];
                    });
          } else {
               return [];
          }
     }

     getDriverIdQuiz(language: string) {
          const applicant = this.formUserIdentityRequest(language);
          if (applicant) {
               const url: string = `${environment.APP_API_URL}/api/v1/IdentityVerify/VerifyIdentity`;
               return axios.post(url, applicant, {
                    headers: {
                         'Content-Type': 'application/json'
                    }
               })
                    .then((response) => (response.data as any))
                    .catch((error) => {
                         console.error(error);
                         return null;
                    });
          } else {
               return null;
          }
     }

     gradeDriverIdQuiz(idQuiz: QuestionSet, language: string): any {
          const payload = this.formVerifyQuizRequest(idQuiz, language);

          if (payload) {
               const url: string = `${environment.APP_API_URL}/api/v1/IdentityVerify/VerifyQuiz/${idQuiz.conversationId}`;
               return axios.put(url, payload, {
                    headers: {
                         'Content-Type': 'application/json'
                    }
               })
                    .then((response) => (response.data as any))
                    .catch((error) => {
                         console.error(error);
                         return undefined;
                    });
          } else {
               return undefined;
          }
     }

     formUserIdentityRequest(language: string): UserIdentityRequest | any {
          let userIdentityRequest: UserIdentityRequest;

          if (this.driverRequest.firstName &&
               this.driverRequest.lastName &&
               this.driverRequest.dateOfBirth &&
               this.driverRequest.emailAddress &&
               this.driverRequest.address &&
               this.driverRequest.address.phoneNumber) {

               const licenses: License[] = [];
               let counter = 1;
               this.driverRequest.driversLicenses.forEach(license => {
                    licenses.push({
                         issuer: license.state,
                         number: license.licenseNumber,
                         sequence: counter,
                         type: 'drivers'
                    });
                    counter++;
               });

               let streetAddress = this.driverRequest.address.addressLine1.trimEnd();
               if (this.driverRequest.address.addressLine2 && this.driverRequest.address.addressLine2.length > 0) {
                    streetAddress += ' ' + this.driverRequest.address.addressLine2;
               }

               const month = this.driverRequest.dateOfBirth.toString().substring(5, 7);
               const day = this.driverRequest.dateOfBirth.toString().substring(8, 10);
               const year = this.driverRequest.dateOfBirth.toString().substring(0, 4);

               const person = {
                    addresses: [
                         {
                              streetAddress1: streetAddress,
                              city: this.driverRequest.address.city,
                              state: this.driverRequest.address.state,
                              zip5: this.driverRequest.address.zip,
                              country: 'US',
                              context: 'primary'
                         }
                    ],
                    context: 'primary',
                    DOB: {
                         context: null,
                         properties: {
                              day: day,
                              month: month,
                              year: year
                         }
                    },
                    emails: [
                         this.driverRequest.emailAddress
                    ],
                    licenses: licenses,
                    name: {
                         firstName: this.driverRequest.firstName,
                         lastName: this.driverRequest.lastName
                    },
                    phones: [
                         {
                              number: this.driverRequest.address.phoneNumber,
                              context: 'home'
                         }
                    ],
                    ssn: {
                         type: 'ssn9',
                         number: 'XXXXXXXXX'
                    }
               };

               userIdentityRequest = {
                    type: 'Initiate',
                    settings: {
                         locale: this.formatLanguageForLexisNexis(language),
                         mode: 'live',
                         reference: 'Reference1',
                         venue: 'online'
                    },
                    persons: [
                         person
                    ]
               }
               return userIdentityRequest;
          }
          return null;
     }

     formVerifyQuizRequest(answeredQuiz: QuestionSet, language: string): VerifyQuizRequest | any {
          const verifyQuizRequest: VerifyQuizRequest = {
               type: 'Continue',
               settings: {
                    mode: 'testing',
                    locale: this.formatLanguageForLexisNexis(language),
                    venue: 'online',
                    reference: ''
               },
               answers: {
                    questionSetId: answeredQuiz.questionSetId,
                    questions: [
                    ]
               }
          };
          answeredQuiz.questions.forEach((answeredQuestion: Question) => {
               const finalAnswer: AnsweredQuestion = {
                    questionId: answeredQuestion.questionId,
                    choices: [
                         { choice: answeredQuestion.userChoiceId.toString() }
                    ]
               }
               verifyQuizRequest.answers.questions.push(finalAnswer);
          });

          return verifyQuizRequest;
     }

     formatLanguageForLexisNexis(language: string): string {
          let lnLanguage: string = 'en_US';
          if (language.toLowerCase() === 'es') {
               lnLanguage = 'es_ES'
          } else if (language.toLowerCase() === 'fr') {
               lnLanguage = 'fr_CA';
          }

          return lnLanguage;
     }

     initiatePayment(): string | any {
          const driver = this.formDriverDTO();
          if (driver) {
               const url: string = `${environment.APP_API_URL}/api/v1/applicant/InitiatePayment`;
               return axios.post(url, driver, {
                    headers: {
                         'Content-Type': 'application/json'
                    }
               })
                    .then((response) => (response.data as string))
                    .catch((error) => {
                         console.error(error);
                         return undefined;
                    });
          }
     }

     enrollInMonitoring(): string | any {
          const driver = this.formDriverDTO();
          if (driver) {
               const url: string = `${environment.APP_API_URL}/api/v1/applicant/EnrollInMonitoring`;
               return axios.post(url, driver, {
                    headers: {
                         'Content-Type': 'application/json'
                    }
               })
                    .then((response) => (response.data as string))
                    .catch((error) => {
                         console.error(error);
                         return undefined;
                    });
          }
     }

     getAuthCode(orderResult: string, token: string, authMethod: string) {
          const url: string = `${environment.APP_API_URL}/api/v1/applicant/GetAuthCode/${orderResult}/${token}/${authMethod}`;
          return axios.get(url)
               .then((response) => {
                    return response.data as any;
               })
               .catch((error) => {
                    console.error(error);
                    return {};
               });
     }

     openDriverReport(openDriverReportRequest: RenderDriverReportRequest, driverReportView: DriverReportView): string | any {
          // TODO: add JWT or Cookie to the request header of this call. Then check on the API side for Authorization.
          const url: string = `${environment.APP_API_URL}/api/v1/DriverRecord/OpenReport`;
          const config = {
                         headers: {
                              'Content-Type': 'application/json;charset=UTF-8',
                              'Authorization': authHeader()
                         }
                    };
          return axios.post(url, openDriverReportRequest, config)
               .then((response) => {
                    this.recordsService.recordDriverRecordView(driverReportView);
                    return response.data as string;
               })
               .catch((error) => {
                    console.error(error);
                    return '';
               });
     }

     getDriverReportPdf(authCode: string, driverReportView: DriverReportView): [] | any {
          const config = {
               headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader()
               },
               responseType: 'blob' as const,
          };
          const url: string = `${environment.APP_API_URL}/api/v1/DriverRecord/DownloadReport`;
          return axios.post(url, { "authCode": authCode }, config)
          .then((response) => {
              if (response && response.data) {
                  console.log(`Blob size: ${response.data.size}`); // ~240028
                  return response.data.arrayBuffer() // Convert Blob to ArrayBuffer
                      .then((arrayBuffer: any) => {
                          const base64 = btoa(
                              new Uint8Array(arrayBuffer)
                                  .reduce((data, byte) => data + String.fromCharCode(byte), '')
                          );
                          console.log(`Base64 length: ${base64.length}`);
                          this.recordsService.recordDriverRecordView(driverReportView);
                          return base64; // Pass to openPdf
                      });
              }
              console.log('No data in response');
              return null;
          })
          .catch((error) => {
              console.error(error);
              return null;
          });
     }

     getEndUserIp() {
          const ipUrl = 'https://api.ipify.org?format=json';
          return axios.get(ipUrl)
               .then((response) => { return response.data.ip as string; })
               .catch((error) => {
                    console.error(error);
                    return '';
               });
     }

     populateIsLexisNexisOn(): string | any {
          return axios.get(`${environment.APP_API_URL}/api/v1/ConfigData/getConfig?configKey=Lexis-Nexis-On`, {})
               .then((response) => {
                    this.isLexisNexisOn = response.data;
                    return response.data;
               })
               .catch((error) => {
                    console.error(error);
                    return true;
               });
     }

     setTransactionAuthMethod(authCode: string, authMethod: string): any {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };

          const url: string = `${environment.APP_API_URL}/api/v1/DriverRecord/PopulateAuthMethod/${authCode}/${authMethod}`;
          return axios.post(url, {}, config)
               .then((response) => {
                    if (response && response.data) {
                         return response.data as any;
                    }
                    return false;
               })
               .catch((error) => {
                    console.error(error);
                    return false;
               });
     }

     formDriverDTO(): DriverDTO | any {
          let driver: DriverDTO;
          if (this.driverRequest.firstName &&
               this.driverRequest.lastName &&
               this.driverRequest.dateOfBirth &&
               this.driverRequest.emailAddress &&
               this.driverRequest.address) {

               //"1984-08-26T12:00:00.000-05:00"
               var dobMonth = this.driverRequest.dateOfBirth.toString().substring(5, 7);
               var dobDay = this.driverRequest.dateOfBirth.toString().substring(8, 10);
               var dobYear = this.driverRequest.dateOfBirth.toString().substring(0, 4);

               driver = {
                    id: this.driverRequest.id,
                    firstName: this.driverRequest.firstName,
                    lastName: this.driverRequest.lastName,
                    email: this.driverRequest.emailAddress,
                    suffix: this.driverRequest.suffix ?? '',
                    altPhone: this.driverRequest.address.altPhoneNumber ?? '',
                    phone: this.driverRequest.address.phoneNumber ?? '',
                    billingAddressSame: this.driverRequest.billingAddressSame,
                    streetAddress1: this.driverRequest.address.addressLine1,
                    streetAddress2: this.driverRequest.address.addressLine2 ?? '',
                    city: this.driverRequest.address.city,
                    state: this.driverRequest.address.state,
                    postalCode: this.driverRequest.address.zip,
                    middleInitial: this.driverRequest.middleInitial ?? '',
                    driverLicenseNumber: '',
                    driverLicenseState: '',
                    dateOfBirth: dobMonth + '/' + dobDay + '/' + dobYear,
                    driverLicenses: this.driverRequest.driversLicenses,
                    sendSmsMonitoringUpdates: this.driverRequest.sendSmsMonitoringUpdates,
                    isEnrolledInRecordChangeNotifications: this.driverRequest.isEnrolledInRecordChangeNotifications
               };
               if (this.driverRequest.driversLicenses.length > 0) {
                    driver.driverLicenseNumber = this.driverRequest.driversLicenses[0].licenseNumber;
                    driver.driverLicenseState = this.driverRequest.driversLicenses[0].state;
               }

               // Populate the creditCard property with the billing address to send to CCP Checkout
               let billingAddress = this.driverRequest.address;
               if (this.driverRequest.billingAddress && !this.driverRequest.billingAddressSame) {
                    billingAddress = this.driverRequest.billingAddress;
               }
               driver.creditCard = {
                    streetAddress1: billingAddress.addressLine1,
                    streetAddress2: billingAddress.addressLine2,
                    city: billingAddress.city,
                    state: billingAddress.state,
                    postalCode: billingAddress.zip,
                    creditCardType: 1, // property not used
                    number: '',  // property not used
                    verificationNumber: '',
                    expirationDate: '',
                    name: '',
                    tpeInvoiceNumber: '',
                    tpeOrderNumber: '',
                    paymentProcessed: false,
                    paymentAuthorized: false
               }

               return driver;
          }
          return null;
     }

     hydrateDriverRequest(driverDTO: DriverDTO, username: string): void {
          this.driverRequest.id = driverDTO.id;
          this.driverRequest.firstName = driverDTO.firstName;
          this.driverRequest.lastName = driverDTO.lastName;
          this.driverRequest.emailAddress = driverDTO.email;
          this.driverRequest.suffix = driverDTO.suffix;
          this.driverRequest.address = {
               addressLine1: '', addressLine2: '', city: '', country: 'USA', phoneNumber: '', state: '', zip: '',
               faxNumber: '', altPhoneNumber: '', countryId: 0
          };
          this.driverRequest.address.addressLine1 = driverDTO.streetAddress1;
          this.driverRequest.address.addressLine2 = driverDTO.streetAddress2;
          this.driverRequest.address.city = driverDTO.city;
          this.driverRequest.address.state = driverDTO.state;
          this.driverRequest.address.zip = driverDTO.postalCode;
          this.driverRequest.address.phoneNumber = driverDTO.phone;
          this.driverRequest.address.altPhoneNumber = driverDTO.altPhone;
          this.driverRequest.middleInitial = driverDTO.middleInitial;
          this.driverRequest.driversLicenses = driverDTO.driverLicenses;
          this.driverRequest.billingAddressSame = driverDTO.billingAddressSame;
          this.driverRequest.isEnrolledInRecordChangeNotifications = driverDTO.isEnrolledInRecordChangeNotifications ?? false;
          this.driverRequest.sendSmsMonitoringUpdates = driverDTO.sendSmsMonitoringUpdates;

          if (driverDTO.dateOfBirth) {
               const month = Number(driverDTO.dateOfBirth.substring(0, 2));
               const day = Number(driverDTO.dateOfBirth.substring(2, 4));
               const year = Number(driverDTO.dateOfBirth.substring(4, 8));
               this.driverRequest.dateOfBirth = DateTime.fromObject({ year: year, month: month, day: day, hour: 12, minute: 0 });
          }

          if (username) {
               this.driverRequest.username = username;
          }
     }

     getDriverByUsername(username: string): any {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };
          const url = `${environment.APP_API_URL}/api/v1/applicant/getDriverByUsername?username=${username}`;
          return axios.get(url, config)
               .then((response) => {
                    return response.data;
               })
               .catch((error) => {
                    console.error(error);
                    return true;
               });
     }

     saveToLocal() {
          if (environment.NODE_ENV === '' || environment.NODE_ENV === 'local') {
               localStorage.setItem('driverData', JSON.stringify(this.driverRequest));
          }
     }

     loadFromLocal(): boolean {
          if (environment.NODE_ENV === '' || environment.NODE_ENV === 'local') {
               const localInfo = localStorage.getItem('driverData') || null;
               if (localInfo) {
                    this.driverRequest = JSON.parse(localInfo);
                    this.isDriverRequestInitialized = true;
                    return true;
               }
          }
          return false;
     }

     testCCPHistory(token: string) {
          if (this.ccpTokenHistory.includes(token)) {
               return true;
          } else {
               this.ccpTokenHistory.push(token);
               return false;
          }
     }
}
